import * as React from 'react';
type Props = {
  className?: string;
};
export function Chicken({ className }: Props) {
  return (
    <svg
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Chicken"
      className={className}
    >
      <path
        d="M19.4672 34.7744C17.7079 36.6814 14.9774 39.6168 14.8999 39.5502C14.0607 38.8293 12.8248 38.8923 12.1392 39.6904C11.4537 40.4885 11.5781 41.7198 12.4172 42.4407C12.9658 42.9119 13.0069 42.9802 14.0144 43.187C14.1329 43.8157 14.4182 44.1594 14.9668 44.6305C15.8061 45.3514 17.1113 45.343 17.7276 44.4903C18.5987 43.2852 17.4287 41.7653 17.4496 41.74C17.4567 41.7314 20.3813 38.2918 22.0267 36.3567"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.4723 31.9396C22.2807 30.3518 21.176 28.9882 20.6847 26.3611C20.4453 25.0809 17.5563 17.9351 17.9989 14.4234C20.0258 -1.65729 40.2885 4.53645 40.0457 18.8081C39.9678 23.3906 38.543 26.3078 37.9237 27.5598C36.4082 30.6232 30.67 36.1932 23.7388 36.5548C21.6717 36.6627 19.3495 35.4027 19.317 34.3116C19.291 33.4389 20.7547 33.3489 21.4723 31.9396Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.9949 10.0469C31.9949 10.0469 39.1255 16.9689 34.42 25.0465"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
